const DemoTradingAccountContentThree = () => {
  return (
    <div className="how__work__trading">
      <div className="quality-section-market">
        <div className="quality-header-market">
          <h1>Trade Your Way - Anytime, Anywhere</h1>
        </div>
      </div>
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Desktop & Web Platforms</h4>
              </div>
              <p>
                Experience lightning-fast execution, advanced charting tools,
                and seamless multitasking through our desktop and web terminals.
                Perfect for traders who want full analytical depth with a
                professional-grade interface.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Mobile Platforms</h4>
              </div>
              <p>
                Stay connected to the markets wherever you go. Our mobile apps
                bring real-time pricing, one-tap trade execution, and intuitive
                charting to your fingertips, giving you complete control on the
                move.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoTradingAccountContentThree;
